import React, {useEffect, useRef} from "react"
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as handlers from "../../../../Instrument/_redux/instruments/instrumentsHandlers";
import {debounce} from "../../../../../util/Helpers";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../../../_metronic/_helpers";
import CheckBoxInput from "../../../../Common/components/checkbox-input";

const Tab2 = ({tab, onValidate, setTab, selectedInstruments, setFieldValue}) => {

    const instruments = useSelector(({instruments}) => instruments, shallowEqual)
    const dispatch = useDispatch();

    const toggleInstrumentSelected = (instrument) => {
        const id = instrument.instrumentId || instrument.id
        if (selectedInstruments[instrument.instrumentId || instrument.id]) {
            const newInstruments = {...selectedInstruments}
            delete newInstruments[id]
            setFieldValue("assets", newInstruments)
        } else {
            setFieldValue(`assets[${id}]`, instrument)
        }
    }

    /* Instrument Search Input */
    const searchInstrument = e => {
        const query = e.target.value.trim();
        if (query !== "") {
            dispatch(handlers.searchInstruments(query));
        }
    }

    const InstrumentsList = ({instruments}) => instruments?.map((instrument) => (
            <div className="mb-3" key={instrument.instrumentId || instrument.id}>
                <CheckBoxInput
                    name={`assets[${instrument.instrumentId || instrument.id}]`}
                    onChange={() => toggleInstrumentSelected(instrument)}
                    checked={selectedInstruments[instrument.instrumentId || instrument.id]}
                    value={instrument}
                >
                    <div className="menu-item d-flex justify-content-center align-items-center">
                        <img
                            className="mx-3"
                            alt={instrument.symbol && instrument.symbol[0]}
                            src={instrument.imageUrl}
                            width="36px"
                            onError={e => {
                                e.target.onerror = null;
                                e.target.src = toAbsoluteUrl("/media/svg/icons/Shopping/Box3.svg")
                            }}
                        />
                        <span className="menu-text">
                            {`${instrument.symbol}`?.substr(0, 20)}
                            <br/>
                            {instrument.name.substr(0, 20)}
                        </span>
                    </div>
                </CheckBoxInput>
            </div>
        )
    );


    return (
        <div
            className="form mt-0 mt-lg-10"
        >
            <div
                className="pb-5"
                data-wizard-type="step-content"
                data-wizard-state={tab === 2 ? "current" : ""}
            >
                <div className={"row"}>
                    <div className="col">
                        <div className="d-flex mb-6">
                            <div className="input-icon h-40px">
                                <input
                                    type="text"
                                    className="form-control form-control-lg form-control-solid h-40px"
                                    placeholder="Search Instruments"
                                    autoComplete="off"
                                    onInput={debounce(searchInstrument, 1000)}
                                />
                                <span>
                                    {
                                        instruments.isLoading ?
                                            <div className="spinner-border spinner-border-sm text-primary"
                                                 role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                            :
                                            <span className="svg-icon svg-icon-lg">
                                                <SVG
                                                    src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                                                />
                                            </span>
                                    }
                                </span>
                            </div>
                        </div>
                        <InstrumentsList instruments={instruments?.data}/>
                    </div>
                    <div className="col">
                        <div className="mb-10 h3 font-weight-bold text-dark">Theme Instruments</div>
                        <InstrumentsList instruments={Object.values(selectedInstruments)}/>
                    </div>
                </div>


                {/* <!--begin: Wizard Actions--> */}
                <div className="d-flex justify-content-between border-top mt-5 pt-10">
                    <div className="mr-2">
                        <button
                            onClick={_ => setTab(1)}
                            type="button"
                            className="btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4"
                        >
                            Previous
                        </button>
                    </div>
                    <div>
                        <button
                            type="button"
                            onClick={onValidate}
                            className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4"
                        >
                            Next
                        </button>
                    </div>
                </div>
                {/* <!--end: Wizard Actions--> */}
            </div>
        </div>
    )
}

export default Tab2;